<ion-text class="lbl-op05-12 ion-float-right">{{formValue | characterCountPipe:allowLimit}}</ion-text>